import React, { createRef, useState } from 'react';
import Chevron from 'assets/icons/chevron-right.svg';
import { Link } from 'gatsby';
import useClickOutside from 'helpers/use-click-outside';
import { classnames } from 'helpers/utils';
import * as styles from './drop-down.module.scss';

export type DropdownElement = {
  value: string;
  slug: string;
};

interface DropdownProps {
  elements: DropdownElement[];
  className?: string;
}

export const DropdownMenu = ({ elements, className }: DropdownProps) => {
  const selectedChoice = (elements[0].value);
  const [isExpanded, setIsExpanded] = useState(false);

  const rootRef = createRef<HTMLDivElement>();

  const handleSelectedClick = () => {
    setIsExpanded(!isExpanded);
  };

  useClickOutside(rootRef, () => setIsExpanded(false));

  const optionsWithoutSelected = elements.slice(1);
  return (
    <div ref={rootRef} className={`${styles.container} ${className}`}>
      <button onClick={handleSelectedClick} className={classnames(styles.dropdownButton, styles.expandSectionButton, isExpanded ? styles.expanded : '')}>
        <p className={styles.selectedChoice}>{selectedChoice}</p>
        <Chevron className={isExpanded ? styles.expanded : ''} />
      </button>
      <div className={styles.optionsContainer}>
        {isExpanded
        && optionsWithoutSelected.map(({ value, slug }) => (
          <div className={styles.option} key={slug}>
            <Link
              to={`/${slug}`}
            >
              <div className={styles.optionItem}>
                {value}
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};
